import { EntityActions, state } from '@travelnest/entities';

import IEntities from './entities';

const { reducer, actions } = state<IEntities>();

export type IEntityState = ReturnType<typeof reducer>;
export type IEntityActions = EntityActions<IEntities>;

export { reducer, actions };

// not needed until we completely move to using external entities module
// export const store = createStore(reducer, applyMiddleware(thunk.withExtraArgument<typeof api>(api)));
